import React from 'react';

export const getTopThree = (top3) => {
  return (
    <span className="bold text-tuna">
      {`${top3[0]}, ${top3[1]} and ${top3[2]}`}
    </span>
  )
};

export const getTopFive = (insight) => {
  return (
    <span className="bold text-tuna">
      {`${insight['top5'][0]['name']}, ${insight['top5'][1]['name']},
      ${insight['top5'][2]['name']}, ${insight['top5'][3]['name']}
      and ${insight['top5'][4]['name']}`}
    </span>
  )
};

export const getDayOfWeek = (id) => {
  if(typeof id === 'string') id = parseInt(id);

  switch(id) {
    case 1:
      return 'Monday';
    case 2:
      return 'Tuesday';
    case 3:
      return 'Wednesday';
    case 4:
      return 'Thursday';
    case 5:
      return 'Friday';
    case 6:
      return 'Saturday';
    case 7:
      return 'Sunday';
  }
};

export const getBottomThree = (insight) => {
  return (
    <span className="bold text-tuna">
      {`${insight['bottom3'][0]['name']}, ${insight['bottom3'][1]['name']} and ${insight['bottom3'][2]['name']}`}
    </span>
  )
};

export const getAnswer = (insight, answerCode) => {
  return (
    <span className="bold text-tuna">
      {`${insight.answers.find(answer => answer.code === answerCode).value}%`}
    </span>
  )
};
